import { createContext } from 'react';
export const PopoverNextContext = createContext(null);
//# sourceMappingURL=PopoverNext.context.js.map